/**
 * Shared UI component for UI Page Header.
 * PARENT-CHILD CONTRACT: parent screens provide the data and configuration that
 * this wrapper renders or normalizes for reuse across the application.
 */
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { UiLabelTranslatePipe } from '../ui-label-translate.pipe';

/**
 * COMPONENT: Ui Page Header
 * Inputs: Uses the parameters, injected services, route state, or signal state declared by this file.
 * Output: Returns the documented value or updates component/service state without changing the public contract.
 * Processing: Documents the Angular declaration that connects this class to templates, dependency injection, or template transforms.
 */
@Component({
  selector: 'ui-page-header',
  standalone: true,
  imports: [UiLabelTranslatePipe],
  templateUrl: './ui-page-header.component.html',
  styleUrl: './ui-page-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiPageHeaderComponent {
  /** PARENT-CHILD CONTRACT: actionsAriaLabel documents the input state boundary used by this file. */
  readonly actionsAriaLabel = input('Page actions');
}
